module.exports = __webpack_public_path__ + "static/media/play-background-3.c6bb204c.mp3";